<template>
  <div :class="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'nuts' : ''">
    <div class="header">
      <a :href="logoLink">
        <img :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/logo.svg' : '/static/img/register/email/status/KKBrand_Logo.png'">
      </a>
    </div>
    <div class="container">
      <div class="email_status">
        <p class="email_status_title">
          {{ $t('register.LAB_EMAIL_VERIFIED')}}
        </p>
        <img :src="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? '/static/img/register/email/status/email_verified_nuts.png' : '/static/img/register/email/status/email_verified.png'">
        <p class="description" v-html="$t('register.LAB_EMAIL_DOWNLOAD_TIPS')" />
      </div>
    </div>
    <div class="divider" />
    <div :class="siteType.GetSiteType() == siteType.SITE_TYPE_NUTS ? 'download_section_nuts' : 'download_section'">
      <p class="title">
        {{ $t('register.LAB_EMAIL_DOWNLOAD')}}
      </p>
      <div class="inside">
        <download-button />
      </div>
    </div>
  </div>
</template>
<script>
import downloadButton from '@/components/downloadButton.vue'
import { getFingerprint, toBury } from '@/configs/userStatsTrack'
import siteType from '@/configs/siteType'
import { logoLinkMixin } from '../../mixin/logoLink'

export default {
  name: 'verifiedPage',
  mixins: [logoLinkMixin],
  components: {
    downloadButton
  },
  data () {
    return {
      status_icon: '',
      platform: '',
      legal: '',
      fingerprint: '',
      clubId: '',
      hostId: '',
      siteType,
    }
  },
  created () {
    const localLegal = JSON.parse(localStorage.getItem('legal'))
    this.legal = localLegal.legal
    this.platform = localLegal.platform
    this.clubId = this.$route.query.clubId
    this.hostId = this.$route.query.hostId
    getFingerprint(this).then(() => {
      this.track()
    })
  },
  methods: {
    track() {
      const buryType = !this.clubId ? 'WebRegisterSuccess' : 'InviteWebRegisterSuccess'
      const f3 = !this.clubId ? 1 : 2
      const f4 = this.hostId ? this.hostId : 0
      toBury(this, buryType, 804, 1, f3, f4, 1, this.platform, this.clubId, this.legal)
    }
  }
}
</script>
<style>
body,
#default-layout {
  background-color: #050505;
  height: 100%;
}
html,
body,
#default-layout {
  height: 100%;
}
</style>
<style lang="less" scoped>
.header{
  height: 70px;
  width: 100%;
  background-color: #000000;
  img {
    position: absolute;
    left: 50px;
    top: 15px;
    width: 170px;
    height: auto;
  }
}
.container {
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  position: relative;
  .email_status {
    text-align: center;
    .email_status_title{
      font-size: 32px;
      font-weight: 700;
      color: #FFFFFF;
      margin-top: 32px;
    }
    img{
      width: 100%;
      height: 300px;
      max-width: 300px;
      margin-top: 32px;
    }
    .description {
      font-size: 24px;
      font-weight: 400;
      color: #FFFFFF;
      margin: 32px 50px 65px 50px;
      line-height: 34px;
    }
  }
}
.divider {
  width: 100%;
  height: 5px;
  background-color: #1F995C;
}
.download_section {
  position: relative;
  height: 500px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-image: url('/static/img/register/email/status/download_bg.jpg');
  background: linear-gradient(180deg, rgba(5, 5, 5, 0.75) 0%, #151515 65%) url('/static/img/register/email/status/download_bg.jpg');
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 58px;
    line-height: 58px;
    color: #1F995C;
    font-style: normal;
    padding-top: 120px;
    margin: 0 25px;
  }
  .inside {
    padding-top: 50px; 
    img{
      width: 3.55rem;
      margin-top: 20px;
    }
    .download {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }
  }
}
.download_section_nuts {
  position: relative;
  height: 500px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-image: url('/static/img/register/email/status/download_bg_nuts.jpg');
  background: linear-gradient(180deg, rgba(5, 5, 5, 0.75) 0%, #151515 65%) url('/static/img/register/email/status/download_bg_nuts.jpg');
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 58px;
    line-height: 58px;
    color: rgba(195, 173, 130, 1);
    font-style: normal;
    padding-top: 120px;
    margin: 0 25px;
  }
  .inside {
    padding-top: 50px; 
    img{
      width: 3.55rem;
      margin-top: 20px;
    }
    .download {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }
  }
}
@media only screen and (max-width: 767px) {
  .download_section {
    background-size: auto 100%;
  }
  .download_section_nuts {
    background-size: auto 100%;
  }
}
.nuts .divider {
  background-color: rgba(195, 173, 130, 1);
}
</style>
